import { useMemo } from 'react';
import { useDocumentTypes } from '~/hooks/useDocumentTypes.ts';
import { getInitialDocumentType } from '../constants/applicationDocumentType.ts';
import { ApplicationSubmitFormValues, FormDataSubmit } from '../types.ts';
import { formatDateDDMMYYYY } from '~/helpers/utils.ts';

interface UseFormInitialValuesReturn {
  initialValues: ApplicationSubmitFormValues;
}

const formatOptionalDate = (value: string | Date | null | undefined) =>
  value ? formatDateDDMMYYYY(value) : null;

export const useFormInitialValues = (
  formData: FormDataSubmit | undefined
): UseFormInitialValuesReturn => {
  const { docType } = useDocumentTypes();

  const initialValues = useMemo(
    (): ApplicationSubmitFormValues => ({
      lastName: formData?.lastName || null,
      firstName: formData?.firstName || null,
      middleName: formData?.middleName || null,
      identificationNumber: formData?.identificationNumber || null,
      birthDate: formatOptionalDate(formData?.birthDate),
      documentType: getInitialDocumentType(formData?.documentType, docType || undefined),
      registryRecord: formData?.registryRecord || null,
      documentSeries: formData?.documentSeries || null,
      documentNumber: formData?.documentNumber || null,
      issueDate: formatOptionalDate(formData?.issueDate),
      documentExpiryDate: formatOptionalDate(formData?.documentExpiryDate),
      issuingAuthority: formData?.issuingAuthority || null,
      financialServicesCounterpartyName: formData?.financialServices?.counterpartyName || null,
      financialServicesCounterpartyCode: formData?.financialServices?.counterpartyCode || null,
      businessRelationCounterpartyName: formData?.businessRelationship?.counterpartyName || null,
      businessRelationCounterpartyCode: formData?.businessRelationship?.counterpartyCode || null,
      disagreeWithProcessingPurpose: false,
      disagreeWithPersonalDataScope: false,
      otherReason: false,
      otherReasonDescription: null,
      atLeastOneCheckbox: false,
    }),
    [formData, docType]
  );

  return { initialValues };
};
